import moment from 'moment'

import DataExchange from './DataExchange'

export default class DatesWFFMDataExchange extends DataExchange {
  /**
   * @param {HTMLFormElement} form 
   */
  constructor (form) {
    super(form)

    /** @type {NodeList} */
    this.inputs = form.querySelectorAll('.custom-select-date input[type="text"]')
  }

  get data () {
    return moment.range(
      moment(this.inputs[0].value, 'DD.MM.YYYY'),
      moment(this.inputs[1].value, 'DD.MM.YYYY'),
    )
  }

  set data (value) {
    this.inputs[0].value = value.start.format('DD.MM.YYYY')
    this.inputs[1].value = value.end.format('DD.MM.YYYY')
  }

  get queryComponent () {
    return `DateOfDeparture=${moment(this.inputs[0].value, 'DD.MM.YYYY').format('YYYYMMDD')}&DateOfReturn=${moment(this.inputs[1].value, 'DD.MM.YYYY').format('YYYYMMDD')}`
  }

}



// WEBPACK FOOTER //
// ./src/services/DatesWFFMDataExchange.js